import api from "../../../services/api";

const APIS = {
    REQUESTED_LIST_DATA: "/RequestList/RequestedSamplesList",
    SAMPLE_EDIT_DATA: "/RequestList/requestedListSample",
    SAMPLE_UPDATE_DATA: "/RequestList/updatesample",
    STATUS_DATA: "/RequestList/status/customer",
    SPECIES_DATA: "/Species",
    PRODUCT_TYPE_DATA: "/ProductTypes",
    GET_USER_ROLE: "/Users/role",
    GET_UNITS: "/Units",
    GET_PRODUCT_TRADES: "/ProductTypes/getproducttrades",
    GET_PRODUCTS_BY_TRADE_ID: "/ProductTypes/getproductsbytradeid",
    GET_FEED_TYPE_BY_TRADE_AND_PRODUCT: "/ProductTypes/getfeedtypebytradeandproduct",
    GET_SPECIES_BY_TRADE_AND_PRODUCT_AND_FEED: "/ProductTypes/getspeciesbytradeandproductandfeed",
    GET_PRODUCT_CONFIGURATION: "/ProductTypes/getproductConfiguration"
};

export const getRequestedListData = async (payload = {}) => {
    try {
        const response = await api.post(APIS.REQUESTED_LIST_DATA, payload);
        return response.data;
    } catch (error) {
        console.error("Error fetching requested list data:", error);
        throw error;
    }
};

export const getSampleEditData = async (params = {}) => {
    try {
        const response = await api.get(APIS.SAMPLE_EDIT_DATA, { params });
        return response.data;
    } catch (error) {
        console.error("Error fetching Sample Edit data:", error);
        throw error;
    }
};

export const updateSampleEditData = async (sampleData = {}) => {
    try {
        const payload = {
            sampleId: Number(sampleData.sampleId || sampleData.id || 0),
            productTradeNameId: Number(sampleData.productTradeNameId || sampleData.productTradeName || 0),
            productTypeId: Number(sampleData.productTypeId || sampleData.productType || 0),
            feedTypeId: Number(sampleData.feedTypeId || sampleData.feedType || 0),
            unitId: Number(sampleData.unitId || sampleData.unit || 0),
            speciesId: Number(sampleData.speciesId || sampleData.species || 0),
            locationId: Number(sampleData.locationId || 0),
            companyId: Number(sampleData.companyId || 0),
            lotNumber: String(sampleData.lotNumber || sampleData.phibroLots || ""),
            customerSampleId: String(sampleData.customerSampleId || ""),
            referenceNo: String(sampleData.referenceNo || ""),
            barcodeNumber: String(sampleData.barcodeNumber || ""),
            expectedLevel: String(sampleData.expectedLevel ?? ""),
            cfrMinLevel: String(sampleData.cfrMinLevel || ""),
            cfrMaxLevel: String(sampleData.cfrMaxLevel || ""),
            loqValue: String(sampleData.loqValue || ""),
            salesRepId: Number(sampleData.salesRepId || ""),
            salesRepName: String(sampleData.salesRepName || ""),
            remarks: String(sampleData.remarks || "")
        };
        const response = await api.post(APIS.SAMPLE_UPDATE_DATA, payload);
        return response.data;
    } catch (error) {
        console.error("Error updating sample data:", error);
        throw error;
    }
};

export const getStatusData = async () => {
    try {
        const response = await api.get(APIS.STATUS_DATA);
        return response.data;
    } catch (error) {
        console.error("Error fetching Status data:", error);
        throw error;
    }
};

export const getSpeciesData = async () => {
    try {
        const response = await api.get(APIS.SPECIES_DATA);
        return response.data;
    } catch (error) {
        console.error("Error fetching Species data:", error);
        throw error;
    }
};

export const getProductTypeData = async () => {
    try {
        const response = await api.get(APIS.PRODUCT_TYPE_DATA);
        return response.data;
    } catch (error) {
        console.error("Error fetching Product Type data:", error);
        throw error;
    }
};

export const getUserRole = async () => {
    try {
        const response = await api.get(APIS.GET_USER_ROLE);
        return response.data;
    } catch (error) {
        console.error('Failed to fetch user role:', error);
        throw error;
    }
};

export const getUnits = async () => {
    try {
        const response = await api.get(APIS.GET_UNITS);
        return response.data.map(unit => ({
            id: unit.unitId,
            unitId: unit.unitId,
            name: unit.name,
            description: unit.description,
            isActive: unit.isActive
        }));
    } catch (error) {
        console.error('Failed to fetch units:', error);
        throw error;
    }
};

export const getProductTrades = async () => {
    try {
        const response = await api.get(APIS.GET_PRODUCT_TRADES);
        if (!response.data || !Array.isArray(response.data)) {
            return [];
        }
        return response.data.filter(trade => trade && trade.productTradeNameId && trade.productTradeName);
    } catch (error) {
        console.error('Failed to fetch product trades:', error);
        return [];
    }
};

export const getProductsByTradeId = async (productTradeId) => {
    try {
        if (!productTradeId || isNaN(productTradeId)) {
            console.error(`Invalid productTradeId: ${productTradeId}`);
            return [];
        }
        const response = await api.post(`${APIS.GET_PRODUCTS_BY_TRADE_ID}?ProductTradeId=${productTradeId}`, {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.data || !Array.isArray(response.data)) {
            return [];
        }
        return response.data.filter(type => type && type.productTypeId && type.name);
    } catch (error) {
        console.error('Failed to fetch products by trade id:', error);
        return [];
    }
};

export const getFeedTypeByTradeAndProduct = async (productTradeId, productTypeId) => {
    try {
        if (!productTradeId || !productTypeId || isNaN(productTradeId) || isNaN(productTypeId)) {
            console.error(`Invalid parameters - productTradeId: ${productTradeId}, productTypeId: ${productTypeId}`);
            return [];
        }
        const response = await api.post(`${APIS.GET_FEED_TYPE_BY_TRADE_AND_PRODUCT}?ProductTradeId=${productTradeId}&ProductTypeId=${productTypeId}`, {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.data || !Array.isArray(response.data)) {
            return [];
        }
        return response.data.filter(feed => feed && feed.feedTypeId && feed.feedTypeName);
    } catch (error) {
        console.error('Failed to fetch feed types:', error);
        return [];
    }
};

export const getSpeciesByTradeAndProductAndFeed = async (productTradeId, productTypeId, feedTypeId) => {
    try {
        if (!productTradeId || !productTypeId || !feedTypeId ||
            isNaN(productTradeId) || isNaN(productTypeId) || isNaN(feedTypeId)) {
            console.error(`Invalid parameters - productTradeId: ${productTradeId}, productTypeId: ${productTypeId}, feedTypeId: ${feedTypeId}`);
            return [];
        }
        const response = await api.post(`${APIS.GET_SPECIES_BY_TRADE_AND_PRODUCT_AND_FEED}?ProductTradeId=${productTradeId}&ProductTypeId=${productTypeId}&feedTypeId=${feedTypeId}`, {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.data || !Array.isArray(response.data)) {
            return [];
        }
        return response.data.filter(s => s && s.speciesId && s.speciesName);
    } catch (error) {
        console.error('Failed to fetch species by trade, product and feed:', error);
        return [];
    }
};

export const getProductConfiguration = async (productTradeId, productTypeId, feedTypeId, speciesId) => {
    try {
        if (!productTradeId || !productTypeId || !feedTypeId || !speciesId ||
            isNaN(productTradeId) || isNaN(productTypeId) || isNaN(feedTypeId) || isNaN(speciesId)) {
            console.error(`Invalid parameters - productTradeId: ${productTradeId}, productTypeId: ${productTypeId}, feedTypeId: ${feedTypeId}, speciesId: ${speciesId}`);
            return {};
        }

        const response = await api.post(`${APIS.GET_PRODUCT_CONFIGURATION}?ProductTradeId=${productTradeId}&ProductTypeId=${productTypeId}&feedTypeId=${feedTypeId}&speciesId=${speciesId}`, {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return response.data || {};
    } catch (error) {
        console.error('Failed to fetch product configuration:', error);
        return {};
    }
};

export const formatUserDetails = (data) => {
    return {
        email: data.email || '',
        name: data.name || '',
        roleName: Array.isArray(data.roleName) ? data.roleName : [],
        companyName: data.companyName || '',
        companyId: data.companyId,
        locationName: data.locationName || '',
        locationID: data.locationID,
        salesRep: data.salesRep || '',
        salesRepId: data.salesRepId || '',
        salesRepName: data.salesRepName || ''
    };
};

export const formatProductTypes = (data) => {
    if (!Array.isArray(data)) return [];
    return data.map(product => ({
        id: product.productTypeId,
        productTypeId: product.productTypeId,
        name: product.name,
        description: product.description,
        minLevel: product.minLevel,
        maxLevel: product.maxLevel,
        isActive: product.isActive,
        locationId: product.locationId
    }));
};

export const formatSpecies = (data) => {
    if (!Array.isArray(data)) return [];
    return data.map(species => ({
        id: species.speciesId,
        speciesId: species.speciesId,
        name: species.name,
        description: species.description,
        isActive: species.isActive
    }));
};

export const formatProductTrades = (data) => {
    if (!Array.isArray(data)) return [];
    return data.map(trade => ({
        id: trade.productTradeNameId,
        productTradeNameId: trade.productTradeNameId,
        productTradeName: trade.productTradeName,
        name: trade.productTradeName,
        isActive: trade.isActive
    }));
};

export const formatFeedTypes = (data) => {
    if (!Array.isArray(data)) return [];
    return data.map(feed => ({
        id: feed.feedTypeId,
        feedTypeId: feed.feedTypeId,
        feedTypeName: feed.feedTypeName,
        name: feed.feedTypeName,
        isActive: feed.isActive
    }));
};
